import styled from 'styled-components';
import { colorWhite, mediaQueryMobileMin } from 'styleUtils';
export var Footer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-108ecu6-0"
})(["margin-top:16px;width:100%;"]);
export var BreadCrumbsWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-108ecu6-1"
})(["width:100%;margin:0 auto;"]);
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-108ecu6-2"
})(["width:calc(100% + 32px);margin:0 -16px;padding:0 16px;background:", ";@media ", "{padding-right:40px;padding-left:40px;}"], colorWhite, mediaQueryMobileMin);
export default Wrapper;